<now-wbsuche-lib-unterrichtsform-basis-facette
  [id]="'kombinierte-lernform'"
  [label]="'Hybrides Lernen'"
  [modalId]="'kombinierteLernformen'"
></now-wbsuche-lib-unterrichtsform-basis-facette>
